var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgC = function SvgC(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a8b9cc",
    d: "M14.219 7.664s-.295-2.749-3.022-2.825-4.128 2.062-4.128 5.116 1.548 5.497 4.202 5.497 2.948-3.054 2.948-3.054l5.086.305s.299 2.758-1.829 4.863-4.741 2.448-6.565 2.434c-1.824-.015-4.354.028-6.8-2.477s-2.861-4.939-2.861-7.33.464-5.558 3.372-7.96C6.599.601 8.602 0 10.606 0c8.366 0 8.928 7.716 8.928 7.716l-5.316-.053z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgC);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;